import React, { Component } from "react";

class FileType extends Component {
  getButtonClasses() {
    let classes = "btn btn-circle btn-sm btn-";

    const type = this.props.type;
    switch (type) {
      case "Image":
        classes += "warning";
        break;
      case "Video":
        classes += "success";
        break;
      case "Audio":
        classes += "dark";
        break;
      default:
        classes += "secondary";
    }

    return classes;
  }

  getIconClasses() {
    let classes = "bx bx-sm bx";

    const type = this.props.type;
    switch (type) {
      case "Image":
        classes += "-images";
        break;
      case "Video":
        classes += "s-videos";
        break;
      case "Audio":
        classes += "s-music";
        break;
      default:
        classes += "-file";
    }

    return classes;
  }

  render() {
    return (
      <button
        className={this.getButtonClasses()}
        type="button"
        title={`View ${this.props.type}`}
      >
        <i className={this.getIconClasses()}></i>
      </button>
    );
  }
}

export default FileType;
